import React from 'react';
import { Line } from 'rc-progress';

const ProgressBar = ({ votesCount, maxVotes }) => {
    const percent = maxVotes > 0 ? (votesCount / maxVotes) * 100 : 0;

    return (
        <div className="progress-bar-container">
            <Line
                percent={percent}
                strokeWidth={6}
                trailWidth={6}
                strokeColor={percent > 0 ? "#F20043" : "rgba(0,0,0,0)"}
                trailColor="#2f2e2e"
                style={{
                    width: '100%',
                    height: '4px',
                }}
                strokeLinecap="butt"
            />
        </div>
    );
};

export default ProgressBar;
